import type { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width ?? 24} height={props.height ?? 24} viewBox='0 0 24 24' {...props}>
    <path d='M21.671 20.094l-3.776-3.765a8.797 8.797 0 001.877-5.443 8.886 8.886 0 10-8.886 8.886 8.797 8.797 0 005.443-1.877l3.765 3.776a1.11 1.11 0 001.577 0 1.11 1.11 0 000-1.577zm-17.45-9.208a6.665 6.665 0 1113.33 0 6.665 6.665 0 01-13.33 0z' />
  </svg>
);

export default SvgSearch;
